var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGameboardTitleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 275 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_501_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H275L259.49 30.0747C254.773 39.2219 245.131 45 234.582 45H40.4178C29.8698 45 20.227 39.2219 15.5098 30.0747L0 0Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 275,
    height: 45,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameboardTitleBg);
export default __webpack_public_path__ + "static/media/GameboardTitleBg.c247a41e0c7f5e42dd0416986d20944b.svg";
export { ForwardRef as ReactComponent };